import React, { useState, useEffect } from 'react';
import FormSelect from 'src/components/form-select';
import {
  ISTP,
  ERedundancyProtocol,
  IStpValidationErrors,
} from 'src/modules/network-configuration/models/node-data';

export const defaultSTP: ISTP = {
  redundancyProtocol: ERedundancyProtocol.AUTO,
  bridgePriority: 8,
};

const redundancyProtocolOptions = [
  { label: 'Disabled', value: ERedundancyProtocol.DISABLED },
  { label: 'RSTP', value: ERedundancyProtocol.RSTP },
  { label: 'Let Network Studio choose', value: ERedundancyProtocol.AUTO },
];

const bridgePriorityOptions = [
  { label: '0', value: '0' },
  { label: '4096', value: '1' },
  { label: '8192', value: '2' },
  { label: '12288', value: '3' },
  { label: '16384', value: '4' },
  { label: '20480', value: '5' },
  { label: '24576', value: '6' },
  { label: '28672', value: '7' },
  { label: '32768', value: '8' },
  { label: '36864', value: '9' },
  { label: '40960', value: '10' },
  { label: '45056', value: '11' },
  { label: '49152', value: '12' },
  { label: '53248', value: '13' },
  { label: '57344', value: '14' },
  { label: '61440', value: '15' },
];

interface IProps {
  id: string;
  values: {
    stp?: ISTP;
  };
  setValues: (value: React.SetStateAction<{ stp?: ISTP }>) => void;
  /** From node.data.category.validationErrors.stp (validateNode) */
  errors?: IStpValidationErrors;
}

export default function EditSTP({
  id,
  values,
  setValues,
  errors = {},
}: IProps) {
  const [localValues, setLocalValues] = useState<ISTP>(defaultSTP);

  const handleBridgePriorityChange = (value: string) => {
    const numValue = parseInt(value, 10);
    setLocalValues((prev) => ({ ...prev, bridgePriority: numValue }));
    setValues((prev) => ({
      ...prev,
      stp: {
        ...(prev.stp || defaultSTP),
        bridgePriority: numValue,
      },
    }));
  };

  useEffect(() => {
    setLocalValues(values.stp || defaultSTP);
  }, [values.stp]);

  return (
    <div className="mt-2 space-y-4">
      <div>
        <FormSelect
          label="Redundancy Protocol"
          options={redundancyProtocolOptions}
          value={localValues.redundancyProtocol}
          data-testid={`stp-redundancy-protocol-${id}`}
          onChange={(e) => {
            const redundancyProtocol = e.target.value as ERedundancyProtocol;
            setLocalValues((prev) => ({
              ...prev,
              redundancyProtocol,
            }));
            setValues((prev) => ({
              ...prev,
              stp: {
                ...(prev.stp || defaultSTP),
                redundancyProtocol,
              },
            }));
          }}
        />
      </div>

      <div>
        <FormSelect
          id="bridge-priority"
          name="bridgePriority"
          label="Bridge Priority"
          options={bridgePriorityOptions}
          value={String(localValues.bridgePriority)}
          data-testid={`stp-bridge-priority-${id}`}
          error={errors.bridgePriority}
          onChange={(e) => handleBridgePriorityChange(e.target.value)}
        />
      </div>
    </div>
  );
}
